<template>
  <div class="card" :class="{'offLine': data.offlineSign}">
    <div class="concernTime">收藏时间:{{ data.concernTime }}</div>
    <div class="icon">
      <img :src="data.carrierLogoUrl || defaultIcon" alt="logo">
    </div>
    <div class="info">
      <div class="line-name">
        <div class="name">{{ data.productName }}</div>
        <div class="label-list">
          <div class="tax-include" v-if="data.containsTheTariffs">
            <div class="tax-icon">
              <img :src="ossPath + '/pages/queryPrice/icon_tax_include.png'" alt="">
            </div>
            <div style="line-height: 20px;text-align:center;flex: 1">包税</div>
          </div>
          <div v-for="(item, i) in data.labelList.length > 6 ? data.labelList.slice(0, 6) : data.labelList" :key="i">
            <el-tooltip v-if="item.desc" :content="item.desc">
              <div class="label-style">{{ item.label }}</div>
            </el-tooltip>
            <div v-else class="label-style">{{ item.label }}</div>
          </div>
          <el-popover placement="bottom-start" width="120" v-if="data.labelList.length > 6">
            <div>
              <div v-for="(item, i) in data.labelList.slice(6)" :key="i" style="margin-bottom: 10px;">
                <el-tooltip v-if="item.desc" :content="item.desc">
                  <div class="label-style">{{ item.label }}</div>
                </el-tooltip>
                <div v-else class="label-style">{{ item.label }}</div>
              </div>
            </div>
            <div slot="reference" class="rest-label">
              +{{ data.labelList.length - 6 }}
              <i class="el-icon-arrow-right" style="margin-left: -8px;"></i>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="line-info">
        <div class="line-info-item" style="width: 100px;">
          <div class="product-info">
            {{ data.agingIsShow ? data.aging : data.extractionAging }}
            <el-tooltip
              :content="agingType[data.agingType]"
              placement="top-start"
            >
              <i class="el-icon-question" style="color:#C2C2C2;"></i>
            </el-tooltip>
          </div>
          <div class="label">参考时效</div>
        </div>
        <div class="line-info-item" style="width: 77px;margin-left: 47px;">
          <div class="product-info">
            <el-tooltip placement="top">
              <div slot="content" style="max-width: 800px;">{{ data.goodsTypeNames }}</div>
              <div class="goods-type">{{ data.goodsTypeNames }}</div>
            </el-tooltip>
          </div>
          <div class="label">可接货物</div>
        </div>
        <!-- 船公司 -->
        <div class="line-info-item" style="width: 85px;margin-left: 42px;">
          <div class="product-info">
            <template v-if="data.transportCompanyNames">
              <!-- {{ data.landTransportNames || '/' }} -->
              <tooltip :contentInfo="data.transportCompanyNames || '/'">
                <span slot="content" class="transport-company">{{ data.transportCompanyNames }}</span>
              </tooltip>
            </template>
            <template v-else>/</template>
          </div>
          <div class="label" style="margin-top: 3px;">运输公司</div>
        </div>
        <div class="line-info-item" style="width: 56px;margin-left: 49px;">
          <div class="product-info">{{ deliveryTypeName }}<span v-if="data.endDeliveryTypes">-{{ data.endDeliveryTypes }}</span></div>
          <div class="label">派送方式</div>
        </div>
      </div>
    </div>
    <div class="price-info">
      <div class="current">
        现价{{ data.currency }}
        <span class="price-num">{{ data.price }}</span>
        /{{ data.chargeType }}
      </div>
      <div class="previous"></div>
    </div>
    <div style="display:flex;align-items: center;margin-left: auto;margin-right: 30px;flex-shrink: 0;">
      <span
        class="icon_collect"
        @click.stop="unfollowItem"
      >
        <img :src="ossPath + '/pages/queryPrice/icon_favorites.png'" alt="">
        取消订阅
      </span>
      <!-- <el-popover
        :popper-options="{
              boundariesElement: 'body',
              gpuAcceleration: false,
            }"
        placement="top-start"
        title="企业微信在线客服"
        width="160"
        trigger="hover"
      >
        <div>
          <img
            style="
                  width: 130px;
                  height: 130px;
                  margin-left: 15px;
                "
            :src="data.wxUrl || qrCodeImages.wxService"
            alt="微信咨询二维码"
          />
          <p style="text-align: center;">扫一扫联系{{ data.wxUrl ? '专线' : '平台' }}客服</p>
        </div>
        <div
          style="
                cursor: pointer;
                display: flex;
                align-items: center;
                color: #111111;
                font-size: 14px;
                margin-left: 40px;
                flex-shrink: 0;
              "
          slot="reference"
        >
          <img
            style="
                  vertical-align: middle;
                  margin-right: 4px;
                  width: 18px;
                  height: 18px;
                "
            :src="ossPath + '/pages/queryPrice/icon_contact.png'"
            alt=""
          />
          联系{{ data.wxUrl ? '专线' : '平台' }}
        </div>
      </el-popover> -->
      <div
        style="
              cursor: pointer;
              display: flex;
              align-items: center;
              color: #111111;
              font-size: 14px;
              margin-left: 40px;
              flex-shrink: 0;
            "
        @click="showText(data, false, 1)"
        v-if="!data.offlineSign"
      >
        方案详情
        <img :src="ossPath + '/pages/queryPrice/icon_checknow_arrow.png'" alt="" style="margin-left: 4px;">
      </div>
      <div v-else style="width: 68px;margin-left: 40px;"></div>
    </div>
  </div>
</template>
<script>
import { ossPath, qrCodeImages } from '../../../../../devParams';
import tooltip from '../../../placeOrder/components/tooltip.vue'
export default {
  name: 'collectLineItem',
  components: { tooltip },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      defaultIcon: ossPath + "/pages/home/hot_country_default_icon.png",
      qrCodeImages,
      agingType: {
        1: '开船后开始计算时效',
        2: '入仓后开始计算时效'
      },
    }
  },
  computed: {
    deliveryTypeName() {
      const deliveryTypeList = [
        // { label: '卡派', value: 'KP' },
        { label: '海卡', value: 'HK' },
        { label: '海派', value: 'HP' },
        { label: '整柜直送', value: 'WC' },
        { label: '空派', value: 'FP' },
        { label: '空卡', value: 'KK' },
        { label: '自提', value: 'ZT' },
        { label: '快递派', value: 'KDP' },
        { label: '卡航', value: 'KH' },
        { label: '铁路', value: 'TL' }
      ]
      let deliveryType = deliveryTypeList.find(item => item.value === this.data.deliveryType)
      return deliveryType ? deliveryType.label : this.data.deliveryType
    }
  },
  methods: {
    unfollowItem() {
      this.$emit('unfollowItem', this.data)
    },
    showText(item, type, val) {
      this.$emit('detail', item, type, val)
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 100%;
  height: 140px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  transition: 1s ease;
  display: flex;
  position: relative;
  &:hover {
    background: #FCF4F1;
    box-shadow: none;
    border: 1px solid #FF4D01;
  }
}
.offLine {
  background: #EEEEEE;
  &:hover {
    background: #EEEEEE;
    border: 1px solid #EEEEEE;
  }
}
.concernTime {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  position: absolute;
  top: 16px;
  right: 20px;
}
.icon {
  width: 80px;
  height: 80px;
  padding: 20px 0 0 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.info {
  width: 680px;
  margin-left: 10px;
  padding-top: 22px;
  flex-shrink: 0;
  .line-name {
    display: flex;
    .name {
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
    }
    .label-list {
      display: flex;
      align-items: center;
      .tax-include {
        width: 56px;
        height: 20px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-left: 10px;
        border: 1px solid #FFAD02;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFAD02;
        flex-grow: 0;
        .tax-icon {
          width: 19px;
          height: 18px;
          background: #FFAD02;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .label-style {
        min-width: 67px;
        height: 22px;
        display: inline-block;
        background: rgba(254, 174, 32, .1);
        border-radius: 2px;
        text-align: center;
        line-height: 22px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #F39E06;
        cursor: default;
        margin-left: 10px;
        padding: 0 6px;
        box-sizing: border-box;
      }
      .rest-label {
        width: 30px;
        height: 22px;
        box-sizing: border-box;
        background: rgba(254, 174, 32, .1);
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #F39E06;
        line-height: 22px;
        text-align: center;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .line-info {
    display: flex;
    margin-top: 17px;
    &-item {
      height: 46px;
      .label {
        margin-top: 6px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
      .product-info {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #141414;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .goods-type {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.price-info {
  width: 215px;
  margin-left: 85px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #FF4D01;
  line-height: 22px;
  text-align: center;
  .price-num {
    font-size: 24px;
    font-weight: 600;
  }
}
.icon_collect {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #111111;
  line-height: 20px;
  img {
    width: 17px;
    height: 17px;
    margin-right: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/components/collectLineItem.vue